export const prizesData =[
    {
        "id": 114351,
        "infoId": 578,
        "prizeName": "澳朵金喜",
        "alias": null,
        "points": 50,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/hongbao.png",
        "prizeType": 1,
        "prizeTotal": 100,
        "status": 0,
        "received": 0,
        "stockNum": 95,
        "limitMax": 5,
        "projectId": null
    },
    {
        "id": 114363,
        "infoId": 578,
        "prizeName": "手持mini电动电风扇",
        "alias": null,
        "points": 50,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/dianfengs.JPG",
        "prizeType": null,
        "prizeTotal": 50,
        "status": 0,
        "received": 0,
        "stockNum": 50,
        "limitMax": 1,
        "projectId": "114352,114353,114354,114355,114356,114357,114358,114359,114360,114361,114362,114363"
    },
    {
        "id": 114362,
        "infoId": 578,
        "prizeName": "定制款 2024德国欧洲杯纪念品 开瓶器",
        "alias": null,
        "points": 80,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/kaipingqi.JPG",
        "prizeType": null,
        "prizeTotal": 40,
        "status": 0,
        "received": 0,
        "stockNum": 40,
        "limitMax": 1,
        "projectId": "114352,114353,114354,114355,114356,114357,114358,114359,114360,114361,114362,114363"
    },
    {
        "id": 114361,
        "infoId": 578,
        "prizeName": "定制款 2024德国欧洲杯毛巾（35cm*75cm）",
        "alias": null,
        "points": 120,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/maojing.JPG",
        "prizeType": null,
        "prizeTotal": 40,
        "status": 0,
        "received": 0,
        "stockNum": 40,
        "limitMax": 1,
        "projectId": "114352,114353,114354,114355,114356,114357,114358,114359,114360,114361,114362,114363"
    },
    {
        "id": 114352,
        "infoId": 578,
        "prizeName": "一人份套餐抵扣券",
        "alias": null,
        "points": 180,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/dikouquan.JPG",
        "prizeType": 5,
        "prizeTotal": 50,
        "status": 0,
        "received": 0,
        "stockNum": 49,
        "limitMax": 1,
        "projectId": "114352,114353,114354,114355,114356,114357,114358,114359,114360,114361,114362,114363"
    },
    {
        "id": 114360,
        "infoId": 578,
        "prizeName": "艾草养生锤",
        "alias": null,
        "points": 200,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/ysc.JPG",
        "prizeType": null,
        "prizeTotal": 40,
        "status": 0,
        "received": 0,
        "stockNum": 40,
        "limitMax": 1,
        "projectId": "114352,114353,114354,114355,114356,114357,114358,114359,114360,114361,114362,114363"
    },
    {
        "id": 114359,
        "infoId": 578,
        "prizeName": "定制款 2024德国欧洲杯马克杯 一对（350ml，杯高10cm",
        "alias": null,
        "points": 350,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/makebei.JPG",
        "prizeType": null,
        "prizeTotal": 50,
        "status": 0,
        "received": 0,
        "stockNum": 50,
        "limitMax": 1,
        "projectId": "114352,114353,114354,114355,114356,114357,114358,114359,114360,114361,114362,114363"
    },
    {
        "id": 114358,
        "infoId": 578,
        "prizeName": "定制款 2024德国欧洲杯抱枕（40cm*40cm）",
        "alias": null,
        "points": 480,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/baozheng.JPG",
        "prizeType": 5,
        "prizeTotal": 50,
        "status": 0,
        "received": 0,
        "stockNum": 50,
        "limitMax": 1,
        "projectId": "114352,114353,114354,114355,114356,114357,114358,114359,114360,114361,114362,114363"
    },
    {
        "id": 114357,
        "infoId": 578,
        "prizeName": "定制款 2024德国欧洲杯主题背包",
        "alias": null,
        "points": 580,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/beibao.JPG",
        "prizeType": 5,
        "prizeTotal": 20,
        "status": 0,
        "received": 0,
        "stockNum": 20,
        "limitMax": 1,
        "projectId": "114352,114353,114354,114355,114356,114357,114358,114359,114360,114361,114362,114363"
    },
    {
        "id": 114356,
        "infoId": 578,
        "prizeName": "2024德国欧洲杯官方毛绒钥匙扣（14cm）",
        "alias": null,
        "points": 780,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/yaoshikou.JPG",
        "prizeType": 5,
        "prizeTotal": 15,
        "status": 0,
        "received": 0,
        "stockNum": 15,
        "limitMax": 1,
        "projectId": "114352,114353,114354,114355,114356,114357,114358,114359,114360,114361,114362,114363"
    },
    {
        "id": 114353,
        "infoId": 578,
        "prizeName": "两天一晚试住券",
        "alias": null,
        "points": 880,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/shizhuquan.JPG",
        "prizeType": 5,
        "prizeTotal": 5,
        "status": 0,
        "received": 0,
        "stockNum": 5,
        "limitMax": 1,
        "projectId": "114352,114353,114354,114355,114356,114357,114358,114359,114360,114361,114362,114363"
    },
    {
        "id": 114355,
        "infoId": 578,
        "prizeName": "2024德国欧洲杯官方定制T恤",
        "alias": null,
        "points": 980,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/Txu.JPG",
        "prizeType": 5,
        "prizeTotal": 2,
        "status": 0,
        "received": 0,
        "stockNum": 2,
        "limitMax": 1,
        "projectId": "114352,114353,114354,114355,114356,114357,114358,114359,114360,114361,114362,114363"
    },
    {
        "id": 114354,
        "infoId": 578,
        "prizeName": "2024德国欧洲杯官方定制1/4拉链上衣",
        "alias": null,
        "points": 1280,
        "prizeIcon": "https://assets.rurushishi.com/activies/football/jacket.JPG",
        "prizeType": 5,
        "prizeTotal": 1,
        "status": 0,
        "received": 0,
        "stockNum": 1,
        "limitMax": 1,
        "projectId": null
    }
]
